const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const CampaignDetails = ({ campaign, t, safeTotalAmount, formatCurrency: parentFormatCurrency }) => {
  const f = parentFormatCurrency || formatCurrency;

  return (
    <div className="flex flex-1 flex-col space-y-4 [&_label]:text-gray-500 [&>div]:justify-between [&>div]:flex">
      <div className="text-xl font-semibold">
        {campaign?.name}{" "}
        {campaign?.enabled ? (
          <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-sm font-medium text-green-800">
            {t("active_label")}
          </span>
        ) : campaign?.is_archived ? (
          <span className="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-sm font-medium text-red-800">
            {t("archive_label")}
          </span>
        ) : (
          <span className="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-sm font-medium text-red-800">
            {t("deActive_label")}
          </span>
        )}
      </div>

      <div>
        {t("location")} : <label>{campaign?.location?.location_name}</label>
      </div>

      <div>
        {t("duration")} :{" "}
        <label>
          {campaign?.has_duration
            ? `${campaign?.date_start?.split("T")[0]} à ${campaign?.date_end?.split("T")[0]}`
            : t("unlimited")}
        </label>
      </div>

      <div>
        {t("active_days")} :{" "}
        <label>
          {campaign?.date_start
            ? (() => {
                const dateStart = new Date(campaign.date_start);
                const dateEnd = campaign.date_end ? new Date(campaign.date_end) : new Date();
                const timeDifference = Math.abs(dateEnd.getTime() - dateStart.getTime());
                const daysActive = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
                return `${daysActive} ${t("days")}`;
              })()
            : t("campaign_start_not_specified")}
        </label>
      </div>

      <div>
        {t("objective")} :{" "}
        <label>{campaign?.has_objective ? `${f(campaign?.objective)} $` : t("noObjective")}</label>
      </div>

      <div>
        {t("funds_raised")} : <label>{f(safeTotalAmount)} $</label>
      </div>

      <div className="flex flex-1 flex-col">
        {t("description")} : <p className="text-gray-500 mt-4">{campaign?.description}</p>
      </div>
    </div>
  );
};

export default CampaignDetails;
